export const PIPELINE_COLORS = [
  'bg-teal-600',
  'bg-purple-600',
  'bg-orange-600',
  'bg-gray-600',
  'bg-pink-600',
] as const;

export function getPipelineColor(index: number): string {
  return PIPELINE_COLORS[index % PIPELINE_COLORS.length];
}
